import { Field } from 'formik';
import { ModalFooter } from 'reactstrap';
import styled from 'styled-components';
import variaveis from '../../styles/variaveis.scss';

export const FooterStyle = styled(ModalFooter)`
  && {
    border-top: 0;
  }
`;

export const TextareaStyle = styled(Field)`
  && {
    width: 100%;
  }
`;

export const Mensagem = styled.p`
  	text-align:justify;
	overflow-y: hidden;
`;

export const RequiredField = styled.span`color: ${variaveis.red};`;
